export default "__VITE_ASSET__qNgSGqOf__"